import React from 'react';
import styled from 'styled-components';
import { HorBarGraph } from './HorBarGraph';

const Style = styled.div`
	width: 100%;
	height: 264px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	background: ${props => props.theme.white};
	color: ${props => props.theme.defaultFontColor};

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		height: 238px;
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		height: 365px;
	}
`;

export const HorBarGraphContainer = ({ cypressId, id }) => {
	return (
		<Style id={id} data-cy={cypressId} className='hor-bar-graph-container'>
			<HorBarGraph containerId={'container'} name='ALL' average={631} commit={814} />
			{/* <HorBarGraph containerId={'container2'} name='ATL' average={131} commit={314} /> */}
			<HorBarGraph containerId={'container3'} name='BHM' average={131} commit={200} />
			<HorBarGraph containerId={'container4'} name='CHA' average={6} commit={50} />
		</Style>
	);
};
